import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Button} from '@mui/material';
import DocumentOverlay from './document-overlay';

interface Props extends React.HTMLProps<HTMLDivElement> {
    url: string;
    faIconClass: string;
	color?: any;
    right?: number;
    bottom?: number;
}

type State = {
	documentIsShowing: boolean;
    right: number;
    bottom: number;
};

class FloatingTrigger extends React.Component<Props, State> {
	floatingButton: any;
	constructor(props: Props) {
		super(props, {});
		this.state = {
            documentIsShowing: false,
            right: props.right || 15,
            bottom: props.bottom || 15
		};
		this.floatingButton = document.createElement('div');
	}
    UNSAFE_componentWillReceiveProps(newProps:Props){
        this.setState({right: newProps.right || 15, bottom: newProps.bottom || 15 })
    }

	componentWillUnmount() {
		document.body.removeChild(this.floatingButton);
	}

	documentClosed = () => {
		this.setState({ documentIsShowing: false });
	};

	handleClick = () => {
		this.setState({ documentIsShowing: true });
		document.body.removeChild(this.floatingButton);
	};
	
	render() {
		
		const { url, color, faIconClass } = this.props;
		const { documentIsShowing, right, bottom } = this.state;
		var content: any;
		if (documentIsShowing) {
			content = <DocumentOverlay onClose={this.documentClosed.bind(this)} url={url} />;
		} else {
			document.body.appendChild(this.floatingButton);
			
			content = (
				<Button
					color={color}
					style={{opacity:0.4, zIndex: 10002, position: 'fixed', right: right, bottom: bottom }}
					onClick={this.handleClick}
					variant="fab"
					aria-label="help"
				>
                    <i style={{fontSize:"2.0em", marginTop:4}} className={faIconClass} />
				</Button>
			);
		}
		
		return ReactDOM.createPortal(content, this.floatingButton);
		
	}
}

export default FloatingTrigger;
